import {
    Crown,
    Zap,
    Headset,
    Wrench,
    Building, ThumbsUp, Award, CheckCircle
} from 'lucide-react';
import ChimneymainImg from '../img/hob-about-img-main.png';
import CTA from './Cta';
import HomeAboutUs from './Home/HomeAboutUs';
import CountUpCards from './CountUpCards';
import HomeServices from './Home/HomeServices';

function TherapySession() {
    return (
        <>
            <section className="hob-about-hero">
                <div className="hob-about-hero-content">
                    <h1 className="hob-about-title">
                        Begin Your Journey to Emotional Well-being
                    </h1>
                    <p className="hob-about-subtitle">
                        Compassionate, evidence-based therapy in a safe space for your growth.
                    </p>
                </div>
            </section>


            <HomeServices />

            <CTA />
        </>
    );
}

export default TherapySession;
